import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SwapOutlinedSvg from "@ant-design/icons-svg/es/asn/SwapOutlined";
import AntdIcon from "../components/AntdIcon";
var SwapOutlined = function SwapOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwapOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SwapOutlined.displayName = 'SwapOutlined';
}
export default /*#__PURE__*/React.forwardRef(SwapOutlined);